<template>
  <div class='customSelect' @click="handleClick">
    <div class="select_wrap">
      <template v-if="!data.length">
        <span class="placeholder">{{ placeholder }}</span>
      </template>
      <template v-else>
        <el-tag v-for="(item, index) in data" :key="item.label + item[keyValue] + index" disable-transitions size="mini" :class="item.tagClass" closable @close.self="handleClose(item)">{{ item.label }}</el-tag>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    keyValue: {
      type: String
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {

    };
  },
  methods: {
    handleClick() {
      this.$emit("clickSelect")
    },
    handleClose(val) {
      this.$emit("removeTag", val)
    },
    handleMethods() {},
  },
};
</script>

<style scoped lang="scss">
.select_wrap {
  border: 1px solid #d8dee6;
  border-radius: 3px;
  max-height: 74px;
  line-height: 24px;
  overflow-y: auto;
  // max-width: 99% !important;
  &::-webkit-scrollbar {
    width: 5px; /* Chrome Safari */
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: $--scrollbar-thumb-color; // 滑块颜色
    border-radius: 5px; // 滑块圆角
  }
  &::-webkit-scrollbar-thumb:hover {
    background: $--scrollbar-thumb-hover-color; // 鼠标移入滑块hover
  }
  &:hover {
    border: 1px solid #c9ced5;
    cursor: pointer;
  }
  .el-tag {
    height: 20px;
    line-height: 19px;
    padding: 0 8px;
    margin-left: 5px;
    /deep/ .el-tag__close {
      top: -2px;
      &:hover {
        color: #fff;
        background-color: #767676;
      }
    }
  }
  .placeholder {
    color: #c0c4cc;
    margin-left: 10px;
  }
}
</style>
